import { render, staticRenderFns } from "./BlockType2List.vue?vue&type=template&id=1080c839&scoped=true"
import script from "./BlockType2List.vue?vue&type=script&lang=ts"
export * from "./BlockType2List.vue?vue&type=script&lang=ts"
import style0 from "./BlockType2List.vue?vue&type=style&index=0&id=1080c839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1080c839",
  null
  
)

export default component.exports